import PublicLayout from '@/system/layouts/public/index';
import AppLayout from '@/system/layouts/app';

export default [
	{
		path: '/',
		component: AppLayout,
		meta: { auth: true, hidden: true },
		children: [
			{
				name: '_home',
				path: '/',
				meta: {
					auth: true
				},
				component: import('@/system/views/index.vue')
			},
			{
				name: '_users',
				path: '/_users',
				meta: {
					title: 'Usuarios',
					icon: 'id-card',
					auth: {
						type: 'strict',
						roles: ['_BOSS']
					},
					topbar: {
						buttons: [
							{
								text: 'Nuevo usuario',
								icon: 'plus-square',
								variant: 'primary',
								class: '',
								event: 'newUser'
							}
						]
					}
				},
				component: () => import(/* webpackChunkName: "_users" */ '@/system/views/users/index.vue')
			},
			{
				name: '_usersFormAdd',
				path: '/_users/new',
				meta: {
					title: 'Añadir usuario',
					auth: {
						type: 'strict',
						roles: ['_BOSS']
					},
					breads: [
						{
							name: 'Usuarios',
							url: { name: '_users' },
							icon: 'id-card'
						}
					]
				},
				component: () => import(/* webpackChunkName: "_usersForm" */ '@/system/views/users/form.vue')
			},
			{
				name: '_usersForm',
				path: '/_users/:id',
				meta: {
					title: 'Editar usuario',
					auth: {
						type: 'strict',
						roles: ['_BOSS']
					},
					breads: [
						{
							name: 'Usuarios',
							url: { name: '_users' },
							icon: 'id-card'
						}
					]
				},
				component: () => import(/* webpackChunkName: "_usersForm" */ '@/system/views/users/form.vue')
			},
			{
				name: '_403',
				path: '/403',
				meta: {
					title: 'Error 403',
					auth: false,
					topbar: {
						buttons: [
							{
								text: 'Acceso denegado',
								icon: 'fire',
								variant: 'link',
								class: 'text-dark px-0',
								event: null
							}
						]
					}
				},
				component: () => import(/* webpackChunkName: "_403" */ '@/system/views/system/errors/403.vue')
			},
			{
				name: '_500',
				path: '/500',
				meta: {
					title: 'Error 500',
					auth: false,
					topbar: {
						buttons: [
							{
								text: 'Error interno del aplicativo',
								icon: 'fire',
								variant: 'link',
								class: 'text-dark px-0',
								event: null
							}
						]
					}
				},
				component: () => import(/* webpackChunkName: "_500" */ '@/system/views/system/errors/500.vue')
			}
		]
	},
	// System Pages
	{
		path: '/_system',
		component: PublicLayout,
		redirect: '/_system/login',
		children: [
			{
				name: '_login',
				path: '/_system/login',
				meta: {
					title: 'Login',
					auth: false,
					img: '@/system/assets/images/errors/login.png'
				},
				component: () => import(/* webpackChunkName: "_login" */ '@/system/views/system/public/login/index.vue')
			},
			{
				name: '_forgotPassword',
				path: '/_system/forgot',
				meta: {
					title: 'Forgot Password',
					auth: false
				},
				component: () => import(/* webpackChunkName: "_forgotPassword" */ '@/system/views/system/public/forgot/index.vue')
			},
			{
				name: '_offline',
				path: '/_system/offline',
				meta: {
					title: 'Error de red',
					auth: false
				},
				component: () => import(/* webpackChunkName: "_netErr" */ '@/system/views/system/public/offline.vue')
			},
			{
				name: '_404',
				path: '/_system/404',
				meta: {
					title: 'Error 404',
					auth: false
				},
				component: () => import(/* webpackChunkName: "_404" */ '@/system/views/system/public/404.vue')
			}
		]
	},
	// Redirect to 404
	{
		path: '*',
		redirect: '/_system/404'
	}
];
